import { createAmount } from "@chromia/ft4";
import memoize from 'memoize';

import { iParams, iQueryError, iPricePool, iChrBalance, iExerciseRequestFinalizeEvent, iTakeOrderEvent, iExpiredOption } from "../../../interfaces/chrInterfaces";
import { store } from "../../../store/store";
import { getGtxClient } from "./getGtxClient";
import { eModalsActionTypes } from "../../../store/modals/modalsTypes";
import { cBigNumber } from "../../../classes/BigNumber";
import { getChrOptionById } from "./getMainBalances";
import { iOption } from "../../../interfaces/interfaces";
import { eChromiaActionTypes } from "../../../store/chromia/chromiaTypes";

export const getChrTime = async () => {
	try {
		// console.log('hedget.GetTime Query');
		const res = await (await getGtxClient()).query("hedget.GetTime", {});
		// console.log('hedget.GetTime: ', res);
		return res;
	} catch (error) {
		catchQueryError(error);
		throw error;	// ?
	}
}

export const getAllAssetsQuery = async () => {
	try {
		// console.log('ft4.get_all_assets Query');
		const res: any = await (await getGtxClient()).query("ft4.get_all_assets", { page_size: 1000, page_cursor: null });

		// console.log("res: ", res);

		// let res_arr: Asset[] = [];
		const resArr: any[] = [];
		for (let i = 0; i < res.data.length; ++i) {
			//res_str += (arr[i] as string) + "\n";
			resArr.push({
				id: res.data[i].id,
				id_str: res.data[i].id.toString('hex'),
				symbol: res.data[i].symbol,
				name: res.data[i].name,
				dec: res.data[i].decimals,
				tot_supply: createAmount(res.data[i].supply, res.data[i].decimals),
				supply: res.data[i].supply.toString()
			})
		}
		console.log('getAllAssetsQuery: ', resArr);
		// set_assets_arr(res_arr);
		return resArr;
	} catch (error) {
		catchQueryError(error);
		throw error;	// ?
	}
}

export const getAssetBalanceQuery = async (userAddres: string, tokenAddress: string) => {
	try {
		// console.log('ft4.get_asset_balance Query');
		const res = await (await getGtxClient()).query("ft4.get_asset_balance", { account_id: userAddres, asset_id: tokenAddress});
		return res;
	} catch (error) {
		catchQueryError(error);
		throw error;	// ?
	}
}

// export const getAssetBalancesQuery = async (userAddres: string): Promise<iChrBalance[]> => {
/* export const getAssetBalancesQuery = async (userAddres: string) => {
	try {
		const res = await (await getGtxClient()).query("ft4.get_asset_balances", { account_id: userAddres, page_size: 100, page_cursor: null});
		return res;
	} catch (error) {
		catchQueryError(error);
		throw error;	// ?
	}
} */
export const getAssetBalancesQuery = async (userAddres: string): Promise<iChrBalance[]> => {

	// const response = await (await getGtxClient()).query("ft4.get_asset_balances", { account_id: chrClientAddr, asset_id: assetId });
	// console.log('ft4.get_asset_balances Query');
	const response = await (await getGtxClient()).query("ft4.get_asset_balances", { account_id: userAddres,  page_size: 100, page_cursor: null});	// fix

	const res = response.data.map(balance => { return {
		balance: new cBigNumber(balance.amount.toString(), {decimals: balance.asset.decimals, currentDecimals: balance.asset.decimals}),
		asset: {
			address: balance.asset.id.toString('hex'),
			decimals: balance.asset.decimals,
			currency: balance.asset.name,
			// showDecimals: number,
			iconUrl: balance.asset.icon_url,
			symbol: balance.asset.symbol,
		}
	}});

	// console.log('ft4.get_asset_balances: ', res);

	return res;
}

export const getParamsQuery = async (): Promise<iParams> => {
	try {
		// console.log('hedget.GetPrms Query');
		const response = await (await getGtxClient()).query("hedget.GetPrms", {});
		const res: iParams = {
			account: {
				buffer: response.acc,
				string: response.acc.toString('hex')
			},
			autoexerciseTime: response.auto_exc_time,
			commissionToken: {
				buffer: response.com_tok,
				string: response.com_tok.toString('hex')
			},
			exerciseFee: new cBigNumber(response.exc_fee),
			inited: Boolean(response.inited),
			makerFee: new cBigNumber(response.maker_fee),
			owner: {
				buffer: response.owner,
				string: response.owner.toString('hex')
			},
			takerFee: new cBigNumber(response.taker_fee),
		};
		// console.log('getParamsQuery: ', res);
		return res;
	} catch (error) {
		catchQueryError(error);
		throw error;	// ?
	}
}

export const getAllOptionsQuery = async () => {
	try {
		// console.log('hedget.GetAllOpts Query');
		const res = await (await getGtxClient()).query("hedget.GetAllOpts", {});
		// console.log("all options: ", res);
		return res;
	} catch (error) {
		catchQueryError(error);
		throw error;	// ?
	}
}

export const getActiveOptionsQuery = async () => {
	try {
		// console.log('hedget.GetActiveOpts Query');
		const res = await (await getGtxClient()).query("hedget.GetActiveOpts", {});
		// console.log("active options: ", res);
		return res;
	} catch (error) {
		catchQueryError(error);
		throw error;	// ?
	}
}

export const getClientOptionBalancesQuery = async () => {
	const { chrUserAddress } = store.getState().chromia;
	if (!chrUserAddress) throw new Error('');

	try {
		// console.log('hedget.GetNonzeroBals Query');
		const res = await (await getGtxClient()).query("hedget.GetNonzeroBals", {from: chrUserAddress});
		// console.log("get_client_options_bals: ", res);
		return res;
	} catch (error) {
		catchQueryError(error);
		throw error;	// ?
	}
}

export const getOptionOrdersQuery = async (optionId: string) => {
	try {
		// console.log('hedget.GetNonzeroOptOrds Query');
		const res = await (await getGtxClient()).query("hedget.GetNonzeroOptOrds", {opt_id: optionId});
		// console.log("get option orders: ", res);
		return res;
	} catch (error) {
		console.log('hedget.GetNonzeroOptOrds Query failed');
		catchQueryError(error);
		throw error;	// ?
	}
}

export const getClientOrdersQuery = async () => {
	const { chrUserAddress } = store.getState().chromia;
	if (!chrUserAddress) throw new Error('');

	try {
		// console.log('hedget.GetNonzeroOrds Query');
		const res = await (await getGtxClient()).query("hedget.GetNonzeroOrds", {from : chrUserAddress});
		// console.log("get client orders: ", res);
		return res;
	} catch (error) {
		// console.log('hedget.GetNonzeroOrds Query failed');
		catchQueryError(error);
		throw error;	// ?
	}
}

/**
 * Use getChrOptionById instead.
 */
// export const getOptionByIdQuery = memoize(async (optionId: string) => {
export const getOptionByIdQuery = async (optionId: string) => {
	try {
		// console.log('hedget.GetOptById Query');
		const res = await (await getGtxClient()).query("hedget.GetOptById", {opt_id: optionId});
		// console.log('getOptionById ', optionId, ' : ', res);
		return res;
	} catch (error) {
		catchQueryError(error);
		throw error;	// ?
	}
};

export const getOrderPriceQuery = async (orderId: number | string) => {	// number
	try {
		// console.log('hedget.GetOrdPrice Query');
		const res = await (await getGtxClient()).query("hedget.GetOrdPrice", {ord_id: orderId});
		// console.log('GetOrderPrice ', ord_id, ' : ', res);
		return res;
	} catch (error) {
		catchQueryError(error);
		throw error;	// ?
	}
}

export const getPricePools = memoize(async (): Promise<iPricePool[]> => {
	try {
		// console.log('hedget.GetPricePools Query');
		const response = await (await getGtxClient()).query("hedget.GetPricePools", {});
		const res: iPricePool[] = response.map(pool => {
			return {
				pool: pool.pool.toString('hex'),
				t0: pool.t0.toString('hex'),
				t1: pool.t1.toString('hex'),
			}
		})
		// console.log('GetPricePools: ', res);
		return res;
	} catch (error) {
		catchQueryError(error);
		throw error;	// ?
	}
});

export const getExpiredOptions = async (address: string) => {
	const { systemTimestamp } = store.getState().app;
	if (!systemTimestamp) return;
	// console.log('____________________________________');
	try {
		// console.log('hedget.get_events Query');
		const response: (iExerciseRequestFinalizeEvent | iTakeOrderEvent)[] = await (await getGtxClient()).query("get_events", {
			names: ['Hedget.OptionExerciseReqFin', 'Hedget.OrderTake'],
			from_block: undefined,
			to_block: undefined,
			from_time: undefined,
			to_time: undefined,
			from_event: undefined,
			to_event: undefined,
			count: 1000,	// change
			args: {
				from: address,
			},
		});
		// console.log('getExpiredOptions: ', response)
		/* const ids = response.reduce((acc, event) => {
			if (event.name === 'Hedget.OrderTake') {
				const id = event.opt_id.toString('hex');
				if (!acc.includes(id)) {
					return acc.concat(id);
				}
			}
			return acc;
		}, ([] as string[]));
		console.log('ids: ', ids) */
		const finalizedOpts = response.filter(e => e.name === 'Hedget.OptionExerciseReqFin').map(e => e.opt_id.toString('hex'));
		const optIds: string[] = [];
		response.filter(e => e.name === 'Hedget.OrderTake').forEach(e => {
			const id = e.opt_id.toString('hex');
			if (!optIds.includes(id)) optIds.push(id);
		});
		const options = await Promise.all(optIds.map(id => getChrOptionById(id)));	// process rejection somehow
		// console.log('options: ', options);
		const res: iExpiredOption[] = [];
		// change response maybe
		// response.forEach(async event => {
		response.forEach(async (event, i) => {
			if (event.name === 'Hedget.OrderTake') {
				const id = event.opt_id.toString('hex');
				const option = options.find(option => option.optId === id)!;
				const expired = option.maturityTime < systemTimestamp;
				// console.log('getExpiredOptions 1: ', i);
				if (!expired) return;
				// console.log('getExpiredOptions 2: ', i, '\n', option.maturityPrice, '\n' , option.maturityTime, '\n', systemTimestamp);
				// if (option.maturityPrice.isZero()) return;
				// console.log('getExpiredOptions 3: ', i);
				// console.log('option: ', option);
				const worthfull = option.maturityPrice.isZero()
					? false
					: option.optionType
						? option.maturityPrice.gt(option.strike.initial)
						: option.maturityPrice.lt(option.strike.initial)
				;

				// add check for exercised balance ?
				const index = res.findIndex(e => e.id === id);
				if (index === -1) {
					// console.log('getExpiredOptions 4: ', i);
					// console.log('event: ', event);
					res.push({
						id,
						// amount: new cBigNumber(event.ord_amount),
						amount: new cBigNumber(event.taked_amt),	// add current decimals?
						finalized: finalizedOpts.includes(id),
						worthfull,
						opt: option
					});
				} else {
					// console.log('getExpiredOptions 5: ', i);
					// res[index].amount = res[index].amount.add(event.ord_amount, {raiseValue: true});
					res[index].amount = res[index].amount.add(event.taked_amt, {raiseValue: true});
				}
			}
		})
		console.log('getExpiredOptions res: ', res)
		store.dispatch({
			type: eChromiaActionTypes.SET_EXPIRED_OPTIONS,
			payload: res
		})
	} catch (error) {
		catchQueryError(error);
		throw error;	// ?
	}
}

const catchQueryError = (error: any) => {
	// console.log(Object.keys(err));	// not shows all
	// console.log(Object.getOwnPropertyNames(err));	// shows all

	let modalMessage = 'Something went wrong...';
	if (isQueryError(error)){
		const splittedMessage = error.message.split('failed: ');

		/* if (!trashlessMessage[1]){
			return 'Something went wrong...';
		} */
		
		if (splittedMessage[1]) {
			switch (splittedMessage[1].slice(0, -1)) {	// removes 
				case 'ord_price <= 0 for buy ord':
					modalMessage = 'Order price less than zero!';
					break;
	
				// default:
					// return 'Something went wrong...';
			}
		}
	}/*  else {
		return 'Something went wrong...';
	} */

	/* store.dispatch({
		type: eModalsActionTypes.OPEN_NEW_MODAL,
		payload: {
			modalName: 'info',
			message: modalMessage
		}
	}); */
	console.error(error);	// ?
	// throw new Error(error);	// ?
}

const isQueryError = (error: any): error is iQueryError => {
    return (
      typeof error === "object" &&
      error !== null &&
      ("name" in error && typeof error.name === 'string') &&
      ("status" in error && typeof error.status === 'number') &&
      ("stack" in error && typeof error.stack === 'string') &&
      ("message" in error && typeof error.message === 'string')
    );
}

// SLURPYSWAP

/**
 * Low token - token which price you want.
 */
/* export const getCurrentPriceQuery = async (poolId: string, lowTokenId: string): Promise<cBigNumber> => {
// export const getCurrentPriceQuery = async () => {
	try {
		const res = await (await getChrClient()).query("slurpyswap.GetCurPrice", {pool_id: poolId, low_tok_id: lowTokenId}) as unknown as iGetCurrentPriceQueryResponse;
		// const res = await (await getChrClient()).query("slurpyswap.GetCurPrice", {
		// 	pool_id: '6321841b57d1ee3d24fbd17ab544c3234fb01e30c14b66f6d4edcb8c79875929',	// chr-usdt
		// 	low_tok_id: '0edcc76eb105e18079a6f11b86c78ff59e7e3aaab598f85c762f59eb24d8b96a'	// chr
		// });
		// console.log('GetCurPrice: ', res);
		return new cBigNumber(res.price);
	} catch (error) {
		catchQueryError(error);
		throw error;	// ?
	}
} */
/**
 * Low token - token which price you want.
 */
export const getCurrentPriceQuery = async (poolId: string, lowTokenId: string): Promise<cBigNumber> => {
	// export const getCurrentPriceQuery = async () => {
	try {
		// console.log('slurpyswap.GetObsPrice Query');
		const res = await (await getGtxClient()).query("slurpyswap.GetObsPrice", {pool_id: poolId, low_tok_id: lowTokenId});
		/* const res = await (await getChrClient()).query("slurpyswap.GetCurPrice", {
			pool_id: '6321841b57d1ee3d24fbd17ab544c3234fb01e30c14b66f6d4edcb8c79875929',	// chr-usdt
			low_tok_id: '0edcc76eb105e18079a6f11b86c78ff59e7e3aaab598f85c762f59eb24d8b96a'	// chr
		}); */
		// console.log('GetObsPrice: ', res);
		return new cBigNumber(res.price);
	} catch (error) {
		catchQueryError(error);
		throw error;	// ?
	}
}

export const getSlurpyswapTimeQuery = async () => {
	try {
		// console.log('slurpyswap.GetTime Query');
		const res = await (await getGtxClient()).query("slurpyswap.GetTime", {});
		// console.log('slurpyswap.GetTime: ', res);
		return res;
	} catch (error) {
		catchQueryError(error);
		throw error;	// ?
	}
}